import React from 'react';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const Privacy = () => {
  const { t } = useTranslation('terms');
  return (
    <div className="legal">
      <Head>
        <title>{t('privacy.title')}</title>
      </Head>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="mt-12 mb-24 text-wrap">
          <h1>{t('privacy.title')}</h1>
          <p className="mb-8">{t('privacy.lastModified')}</p>
          <h3 className="mb-4 mt-8">{t('privacy.title1')}</h3>
          <p>{t('privacy.sentence1_0_1')}</p>
          <h3 className="mb-4 mt-8">{t('privacy.title2')}</h3>
          <h4>{t('privacy.subtitle2_1')}</h4>
          <p>{t('privacy.sentence2_1_1')}</p>
          <p>{t('privacy.sentence2_1_2')}</p>
          <p>{t('privacy.sentence2_1_3')}</p>
          <h4>{t('privacy.subtitle2_2')}</h4>
          <p>{t('privacy.sentence2_2_1')}</p>
          <h4>{t('privacy.subtitle2_3')}</h4>
          <p>{t('privacy.sentence2_3_1')}</p>
          <h4>{t('privacy.subtitle2_4')}</h4>
          <p>{t('privacy.sentence2_4_1')}</p>
          <h3 className="mb-4 mt-8">{t('privacy.title3')}</h3>
          <p>{t('privacy.sentence3_0_1')}</p>
          <p>{t('privacy.sentence3_0_2')}</p>
          <p>{t('privacy.sentence3_0_3')}</p>
          <p>{t('privacy.sentence3_0_4')}</p>
          <p>{t('privacy.sentence3_0_5')}</p>
          <h3 className="mb-4 mt-8">{t('privacy.title4')}</h3>
          <p>{t('privacy.sentence4_0_1')}</p>
          <p>{t('privacy.sentence4_0_2')}</p>
          <p>{t('privacy.sentence4_0_3')}</p>
          <p>{t('privacy.sentence4_0_4')}</p>
          <p>{t('privacy.sentence4_0_5')}</p>
          <h3 className="mb-4 mt-8">{t('privacy.title5')}</h3>
          <p>{t('privacy.sentence5_0_1')}</p>
          <h3 className="mb-4 mt-8">{t('privacy.title6')}</h3>
          <p>{t('privacy.sentence6_0_1')}</p>
          <p>{t('privacy.sentence6_0_2')}</p>
          <p>{t('privacy.sentence6_0_3')}</p>
          <h3 className="mb-4 mt-8">{t('privacy.title7')}</h3>
          <p>{t('privacy.sentence7_0_1')}</p>
          <p>{t('privacy.sentence7_0_2')}</p>
          <h3 className="mb-4 mt-8">{t('privacy.title8')}</h3>
          <p>{t('privacy.sentence8_0_1')}</p>
          <p>{t('privacy.sentence8_0_2')}</p>
          <p>{t('privacy.sentence8_0_3')}</p>
          <h3 className="mb-4 mt-8">{t('privacy.title9')}</h3>
          <p>{t('privacy.sentence9_0_1')}</p>
          <p>{t('privacy.sentence9_0_2')}</p>
          <h3 className="mb-4 mt-8">{t('privacy.title10')}</h3>
          <p>{t('privacy.sentence10_0_1')}</p>
        </div>
      </div>
    </div>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common', 'terms'])),
  },
});

export default Privacy;
